export default __webpack_public_path__ + "static/media/biomarker-logoW.99636585.svg";